import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/goodstransfer',
    component: Layout,
    redirect: '/goodstransfer/list',
    children: [
      {
        path: 'list',
        meta: { title: '货权转移', activeMenu: '/goodstransfer' },
        component: () => import('@/views/orderManage/GoodsTransfer.vue')
      }
    ]
  },
  {
    path: '/orderManage',
    meta: { title: '点价订单管理' },
    component: Layout,
    redirect: '/orderManage/list',
    children: [
      {
        path: 'list',
        meta: { title: '点价订单管理', activeMenu: '/orderManage' },
        component: () => import('@/views/orderManage/OrderManage.vue')
      },
      {
        path: 'detail',
        meta: { title: '点价订单详情', activeMenu: '/orderManage' },
        component: () => import('@/views/orderManage/OrderManageDetail.vue')
      }

    ]
  }

]
